import * as React from 'react';
import { SVGProps } from 'react';

const IconAttachSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.778 4.586a3 3 0 0 0-4.242 0l-7.072 7.07a5 5 0 0 0 7.072 7.072l5.683-5.683 1.414 1.414-5.683 5.683a7 7 0 1 1-9.9-9.9l7.071-7.07a5 5 0 0 1 7.071 7.07l-7.06 7.061a3 3 0 1 1-4.243-4.243l6.354-6.353 1.414 1.414-6.353 6.354a1 1 0 0 0 1.414 1.414l7.06-7.06a3 3 0 0 0 0-4.243z"
    />
  </svg>
);
export default IconAttachSizeM;
